module.exports = window.crypto;


//////////////////
// WEBPACK FOOTER
// ./~/randomhex/src/browser.js
// module id = 652
// module chunks = 0